const event_names = ["MARRIAGE", "BIRTH OF BABY", "ADOPTION OR PLACEMENT FOR ADOPTION OF A CHILD", "OTHERS"];

export const EVENT_NAMES = event_names;

const event_name = {
	marriage: "MARRIAGE",
	birth_of_baby: "BIRTH OF BABY",
	adoption: "ADOPTION OR PLACEMENT FOR ADOPTION OF A CHILD",
	others: "OTHERS"
};

export const EVENT_NAME = event_name;
